<onyx-section [heading]="`${I18N}.heading`">
  <onyx-button
    options
    variant="outlined"
    [size]="24"
    leftIcon="add-outlined"
    (click)="addPermission()"
  >
    {{ 'labels.add' | translate }}
  </onyx-button>

  @if (form().controls.length !== 0) {
    <form>
      @for (permissionGroup of form().controls; track permissionGroup) {
        <app-driver-permission-form
          [form]="permissionGroup"
          [permissions]="permissions$ | async"
          [index]="$index"
          (remove)="removePermission($index)"
        ></app-driver-permission-form>
      }
    </form>
  }
</onyx-section>
